// extracted by mini-css-extract-plugin
export default {"Box":"use-issue-type-editor-module__Box--sFgVA","Box_1":"use-issue-type-editor-module__Box_1--rYYDk","ColorDecorator":"use-issue-type-editor-module__ColorDecorator--JBONy"};